import API_URL from '../config';
import axios from 'axios';

import { getCookie } from './../utils/cookies';

export const addNewUnitApi = async(unitName) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const objectData = {
            Name: unitName
        }

        const res = await axios.post(`${API_URL}/api/V2/unit/addUnit/${id}/${iv}`, objectData, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const updateUnitApi = async(Name, unitId) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const objectData = {
            Name: Name
        }

        const res = await axios.put(`${API_URL}/api/V2/unit/updateUnit/${id}/${iv}/${unitId}`, objectData, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const getAllUnitsApi = async (Name = "") => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/V2/unit/getAllUnits/${id}/${iv}?Name=${Name}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const deleteUnitApi = async(unitId) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.delete(`${API_URL}/api/V2/unit/deleteOneUnit/${id}/${iv}/${unitId}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}
